// Any config specific to Georgia?

export default {
  code: 'UZ',
  countryName: 'Uzbekistan',
  // googleSiteVerificationCode: '1uUi471agIlOfQQ3ns5BSv78-YAYOVbuPdRyGUsfq2I',
  googleSiteVerificationCode: ['X1B_9GgrzG2rdOXBoOKgIif4kvi8_HixLZ0Ouh6Hd3E'],
  countryDomain: 'https://www.carrefour.uz',
  latitude: 41.2766,
  longitude: 69.246,
  defaultAreaCode: 'Yakkasaray District, Tashkent',
  features: {
    languageChange: true,
    now: true,
    share: true,
    isLocationCXEnable: true,
    cashback: false,
    linkMyClubCard: true,
    oneTrustScript: '12a93f69-118c-4846-a89f-319e4744232f'
  }
}
